import { getViewNameByStatus } from 'actions/getViewNameByStatus';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { VideoScreenContainer } from 'components/newIdentifyMethods/VideoScreen/VideoScreenContainer';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { CORREOS, COURIER, IBAN, OFFLINE, VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { COMPLETED, ABORTED, BLOCKED, SUCCESS } from 'constants/statusProcess';
import { START, CALLCENTER_KO, DEFINITE_KO } from 'constants/video/status';
import {
    PATH_IDENTITY_COURIER_FINISHED,
    PATH_IDENTITY_COURIER_SCHEDULED,
    PATH_IDENTITY_IBAN_FINISHED,
    PATH_IDENTITY_IBAN_WAITING,
    PATH_IDENTITY_POST_OFFICE_FINISHED,
    PATH_IDENTITY_POST_OFFICE_SELECTED,
    PATH_IDENTITY_VIDEOCALL_CALLCENTER,
    PATH_IDENTITY_VIDEOCALL_FINISHED,
    PATH_IDENTITY_VIDEOCALL_START,
    PATH_IDENTITY_VIDEOSELFIE_CALLCENTER,
    PATH_IDENTITY_VIDEOSELFIE_FINISHED,
    PATH_IDENTITY_VIDEOSELFIE_START,
} from 'constants/uTagConstants/paths';
import { FormattedText, formatText } from 'core/i18n';
import withIdentifyMethodParser from 'hocs/withIdentifyMethodParser';
import React, { useEffect, useState } from 'react';
import buildTagging from 'routes/formsView/IdentityVerificationView/tagging';
import AbortedView from 'routes/formsView/IdentityVerificationViews/AbortedView';
import BlockedView from 'routes/formsView/IdentityVerificationViews/BlockedView';
import CallCenterKOMessages from 'routes/formsView/IdentityVerificationViews/CallCenterKOMessages';
import IdentityCourierMessages from 'routes/formsView/IdentityVerificationViews/IdentityCourierMessages';
import { IdentityFinishMessageByVideo } from 'routes/formsView/IdentityVerificationViews/IdentityFinishMessageByVideo';
import IdentityIbanFinishMessages from 'routes/formsView/IdentityVerificationViews/IdentityIbanFinishMessages';
import IdentityView from 'routes/formsView/IdentityVerificationViews/IdentityView/IdentityView';
import OfflineView from 'routes/formsView/IdentityVerificationViews/OfflineView';
import PostOfficeSuccessView from 'routes/formsView/IdentityVerificationViews/PostOfficeSuccessView';
import VerificationInProcessView from 'routes/formsView/IdentityVerificationViews/VerificationInProcessView';
import Storage from 'utilities/storage';
import { getFinalizedIdentityVerification, recordedFinalizedIdentityVerification, RELIABLE } from 'utilities/uTagging';

export const IdentityVerification = withIdentifyMethodParser(
    ({
        userProfile,
        mapActions,
        products,
        immStepsState,
        identityValidationActions,
        preLoaderActions,
        actions,
        identificationByCountry,
    }) => {
        const [postOfficeInformation, setPostOfficeInformation] = useState(null);
        const [fetchingPostOffice, setFetchingPostOffice] = useState(false);

        const { doTagRecordPageEvent, doTagRecordPage } = buildTagging({
            userProfile,
            productsDescription: products.get('productsDescription'),
        });

        useEffect(() => {
            const condition1 =
                typeof userProfile.identityMethod !== 'undefined' && userProfile.identityMethod === 'correos';
            const condition2 =
                userProfile.identityStatus === 'programmed' ||
                userProfile.identityStatus === '2' ||
                userProfile.identityStatus === '3';
            identityValidationActions.getVideoIdentificationAvailability(userProfile.accessToken);

            if (condition1 && condition2 && !userProfile.postOfficeAddress) {
                mapActions.getPostOffice(
                    userProfile.postOfficePostalCode,
                    userProfile.postOfficePopulation,
                    userProfile.postOfficeBranch
                );
            }
            if (!immStepsState.get('welcomeCard')) {
                const metodoDefecto = RELIABLE[identificationByCountry()?.[0]];
                doTagRecordPage(metodoDefecto);
            }
        }, []);

        useEffect(() => {
            preLoaderActions.hidePreLoader();
        });

        useEffect(() => {
            const pathByIdentityMethod = {
                [VIDEO_SELFIE]: PATH_IDENTITY_VIDEOSELFIE_START,
                [VIDEO_CALL]: PATH_IDENTITY_VIDEOCALL_START,
            };
            userProfile.identityStatus === 'start' &&
                doTagRecordPageEvent(pathByIdentityMethod[userProfile.identityMethod]);
        }, [userProfile.identityStatus]);

        const onHandleFinishIdentity = () => {
            const currentIndex = immStepsState.get('currentStep');
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });

            actions.enableFinishedAndNextStep();
            const viewName = getViewNameByStatus(userProfile.status);
            actions.changeCurrentStep(
                viewName
                    ? {
                          viewName,
                      }
                    : { index: currentIndex + 1 }
            );
        };

        const renderPostOfficeInformation = () => {
            const postOfficeAddress = userProfile.postOfficeAddress;
            const postOfficePhone = userProfile.postOfficePhone.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            const postOfficeHours1 = userProfile.postOfficeHours1;
            const postOfficeHours2 = userProfile.postOfficeHours2;
            const postOfficeHours3Service = userProfile.postOfficeHours3;
            const postOfficeHours3 =
                Storage.cookies.get('language') === 'en' && postOfficeHours3Service === 'sin servicio'
                    ? 'no service'
                    : postOfficeHours3Service;
            const postOfficeDescription = userProfile.postOfficeDescription;

            const postOfficeInformationComponent = (
                <div className="main-container messages-main-container basic-layering">
                    <MessagesScreen
                        iconClass="icons icons--icon-checked"
                        title={<FormattedText value="messagesScreen-postOffeceFinishTitle" />}
                        buttonText={formatText('button-continue')}
                        showRoadmapNavigation={true}
                        roadmapNavigationProps={{
                            buttonContinueAction: onHandleFinishIdentity,
                            buttonPrevHidden: true,
                        }}
                    >
                        <FormattedText
                            value="messagesScreen-postOffeceFinishContent"
                            injectedStrings={[
                                postOfficeAddress,
                                postOfficePhone,
                                postOfficeHours1,
                                postOfficeHours2,
                                postOfficeHours3,
                                postOfficeDescription,
                            ]}
                        />
                    </MessagesScreen>
                </div>
            );

            setPostOfficeInformation(postOfficeInformationComponent);
        };

        const getIdentityPostOfficerMessages = () => {
            !postOfficeInformation &&
                !fetchingPostOffice &&
                mapActions.getPostOffice(
                    userProfile.postOfficePostalCode,
                    userProfile.postOfficePopulation,
                    userProfile.postOfficeBranch,
                    loaded => {
                        loaded && renderPostOfficeInformation();
                    }
                );
        };

        const getIbanStatusView = () => {
            let view;
            let welcomeCard;

            switch (userProfile.identityStatus) {
                case COMPLETED:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_IBAN_FINISHED);
                    }
                    view = (
                        <IdentityIbanFinishMessages
                            onHandleFinishIdentity={onHandleFinishIdentity}
                            identityIban={userProfile.identityIban}
                        />
                    );
                    welcomeCard = <WelcomeCard />;
                    break;
                case ABORTED:
                    view = <CallCenterKOMessages />;
                    actions.hideWelcomeCard();
                    welcomeCard = null;
                    break;
                default:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_IBAN_WAITING);
                    }
                    view = <IdentityView investmentType={userProfile.investmentType} />;

                    welcomeCard = <WelcomeCard />;
                    break;
            }

            return (
                <div className="identity-verification-views">
                    {view}
                    {welcomeCard}
                </div>
            );
        };

        const checkPostOfficeInformationSaved = addressSaved => {
            addressSaved ? renderPostOfficeInformation() : getIdentityPostOfficerMessages();
        };

        const getCorreosStatusView = () => {
            let view;
            let welcomeCard;
            const status = /[4,5,6,9]/.test(userProfile.identityStatus) ? ABORTED : userProfile.identityStatus;

            switch (status) {
                case '7':
                    view = <VerificationInProcessView />;
                    welcomeCard = <WelcomeCard />;
                    break;
                case BLOCKED:
                    view = <BlockedView />;
                    actions.hideWelcomeCard();
                    welcomeCard = null;
                    break;
                case 'canceled':
                case ABORTED:
                    view = <AbortedView />;
                    actions.hideWelcomeCard();
                    welcomeCard = null;
                    break;
                case SUCCESS:
                case '1':
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_POST_OFFICE_FINISHED);
                    }
                    view = <PostOfficeSuccessView handleFinishIdentity={onHandleFinishIdentity} />;
                    welcomeCard = <WelcomeCard />;
                    break;
                default:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_POST_OFFICE_SELECTED);
                    }

                    view = postOfficeInformation;
                    welcomeCard = null;
                    if (!fetchingPostOffice) {
                        checkPostOfficeInformationSaved(userProfile.postOfficeAddress);
                        setFetchingPostOffice(true);
                    }
                    break;
            }

            return (
                <div className="identity-verification-views">
                    {view}
                    {welcomeCard}
                </div>
            );
        };

        const getCourierStatusView = () => {
            let view;
            let welcomeCard;
            const status = /[4,5,6,9]/.test(userProfile.identityStatus) ? ABORTED : userProfile.identityStatus;

            switch (status) {
                case '7':
                    view = <VerificationInProcessView />;
                    welcomeCard = <WelcomeCard />;
                    break;
                case BLOCKED:
                    view = <BlockedView />;
                    actions.hideWelcomeCard();
                    welcomeCard = null;
                    break;
                case 'canceled':
                case ABORTED:
                    view = <AbortedView />;
                    actions.hideWelcomeCard();
                    welcomeCard = null;
                    break;
                case SUCCESS:
                case '1':
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_COURIER_FINISHED);
                    }
                    view = <PostOfficeSuccessView handleFinishIdentity={onHandleFinishIdentity} />;
                    welcomeCard = <WelcomeCard />;
                    break;
                default:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_COURIER_SCHEDULED);
                    }
                    view = (
                        <IdentityCourierMessages
                            courierAddress={userProfile.courierAddress}
                            courierAddressInfo={userProfile.courierAddressInfo}
                            courierPostoned={userProfile.courierPostoned}
                            courierDate={userProfile.courierDate}
                            onHandleFinishIdentity={onHandleFinishIdentity}
                        />
                    );

                    welcomeCard = <WelcomeCard />;
                    break;
            }

            return (
                <div className="identity-verification-views">
                    {view}
                    {welcomeCard}
                </div>
            );
        };

        const getVideoCallStatusView = () => {
            let view = <IdentityView investmentType={userProfile.investmentType} />;

            switch (userProfile.identityStatus) {
                case COMPLETED:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_VIDEOCALL_FINISHED);
                    }
                    view = (
                        <IdentityFinishMessageByVideo
                            onHandleFinishIdentity={onHandleFinishIdentity}
                            video={VIDEO_CALL}
                            investmentType={userProfile.investmentType}
                            userProfileName={userProfile.name}
                            identityMethod={userProfile.identityMethod}
                        />
                    );
                    break;
                case START:
                    view = <VideoScreenContainer type={VIDEO_CALL} />;
                    break;

                case CALLCENTER_KO:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_VIDEOCALL_CALLCENTER);
                    }
                    view = <CallCenterKOMessages />;
                    actions.hideWelcomeCard();
                    break;
                case ABORTED:
                case DEFINITE_KO:
                    view = <AbortedView />;
                    actions.hideWelcomeCard();
                    break;
                default:
                    break;
            }

            return (
                <div className="identity-verification-views">
                    {view}
                    {userProfile.identityStatus === COMPLETED && <WelcomeCard />}
                </div>
            );
        };

        const getVideoSelfieStatusView = () => {
            let view = <IdentityView investmentType={userProfile.investmentType} />;

            switch (userProfile.identityStatus) {
                case COMPLETED:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_VIDEOSELFIE_FINISHED);
                    }
                    view = (
                        <IdentityFinishMessageByVideo
                            onHandleFinishIdentity={onHandleFinishIdentity}
                            video={VIDEO_SELFIE}
                            investmentType={userProfile.investmentType}
                            userProfileName={userProfile.name}
                            identityMethod={userProfile.identityMethod}
                        />
                    );
                    break;
                case START:
                    view = <VideoScreenContainer type={VIDEO_SELFIE} />;
                    break;
                case DEFINITE_KO:
                    view = <AbortedView />;
                    actions.hideWelcomeCard();
                    break;
                case CALLCENTER_KO:
                    if (!getFinalizedIdentityVerification()) {
                        recordedFinalizedIdentityVerification();
                        doTagRecordPageEvent(PATH_IDENTITY_VIDEOSELFIE_CALLCENTER);
                    }
                    view = <CallCenterKOMessages />;
                    actions.hideWelcomeCard();
                    break;
                default:
                    break;
            }

            return (
                <div className="identity-verification-views">
                    {view}
                    {userProfile.identityStatus === COMPLETED && <WelcomeCard />}
                </div>
            );
        };

        useEffect(() => {
            const condition1 =
                typeof userProfile.identityMethod !== 'undefined' && userProfile.identityMethod === 'correos';
            const condition2 =
                userProfile.identityStatus === 'programmed' ||
                userProfile.identityStatus === '2' ||
                userProfile.identityStatus === '3';
            identityValidationActions.getVideoIdentificationAvailability(userProfile.accessToken);

            if (condition1 && condition2 && !userProfile.postOfficeAddress) {
                mapActions.getPostOffice(
                    userProfile.postOfficePostalCode,
                    userProfile.postOfficePopulation,
                    userProfile.postOfficeBranch
                );
            }
            if (!immStepsState.get('welcomeCard')) {
                doTagRecordPage(RELIABLE[identificationByCountry()?.[0]]);
            }
        }, []);

        useEffect(() => {
            preLoaderActions.hidePreLoader();
        });

        useEffect(() => {
            const pathByIdentityMethod = {
                [VIDEO_SELFIE]: PATH_IDENTITY_VIDEOSELFIE_START,
                [VIDEO_CALL]: PATH_IDENTITY_VIDEOCALL_START,
            };
            userProfile.identityStatus === START &&
                doTagRecordPageEvent(pathByIdentityMethod[userProfile.identityMethod]);
        }, [userProfile.identityStatus]);

        switch (userProfile.identityMethod) {
            case IBAN:
                return getIbanStatusView();
            case CORREOS:
                return getCorreosStatusView();
            case COURIER:
                return getCourierStatusView();
            case VIDEO_CALL:
                return getVideoCallStatusView();
            case VIDEO_SELFIE:
                return getVideoSelfieStatusView();
            case OFFLINE:
                return (
                    <OfflineView
                        identityStatus={userProfile.identityStatus}
                        onCanceledOrAbortedAction={actions.hideWelcomeCard()}
                        onFinishAction={onHandleFinishIdentity}
                    />
                );
            default:
                return <IdentityView investmentType={userProfile.investmentType} />;
        }
    }
);
